export default __webpack_public_path__ + "static/media/chi9.adb49a70.jpg";